import { RadioGroupModel } from "../../../../components";

export const simpleModel1: RadioGroupModel = [
  { value: "value 1", caption: "Label for the value 1", disabled: false },
  {
    value: "value 2",
    caption: "Label for the value 2"
  },
  {
    value: "value 3",
    caption: "Label for the value 3"
  },
  { value: "value 4", caption: "Label for the value 4" },
  {
    value: "value 5",
    caption: "Label for the value 5"
  }
];

export const simpleModel2: RadioGroupModel = [
  { value: "value 1", caption: "Label for the value 1" },
  {
    value: "value 2",
    caption: "Label for the value 2"
  },
  {
    value: "value 3",
    caption: "Label for the value 3",
    disabled: true
  },
  { value: "value 4", caption: "Label for the value 4" },
  {
    value: "value 5",
    caption: "Label for the value 5",
    disabled: true
  },
  {
    value: "value 6",
    caption: "Label for the value 6"
  }
];
